// import React, { useEffect, useState } from "react";
// import { ChevronDown } from 'lucide-react';
import { useNavigate, Link } from "react-router-dom";


// const Navbar = () => {
//     const [scrolled, setScrolled] = useState(false);
//     const navigate = useNavigate()

//     useEffect(() => {
//     const handleScroll = () => {
//         const offset = window.scrollY;
//         if(offset > 50){
//             setScrolled(true);
//         }else{
//             setScrolled(false);
//         }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
// }, []);

// return (
// <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
//       <div className="navbar-logo "><img src="/pravisht-logo.svg"></img></div>
//       <ul className="navbar-links">
//         <li><a href="#" className="underline-hover">About</a></li>
//         <li className="dropdown">
//           <a href="#" className="underline-hover">
//           Services <ChevronDown size={16} className="dropdown-icon" />
//         </a>
//           <ol className="dropdown-menu">
//             <li><a href="#" className="underline-hover">Website Design & Development</a></li>
//             <li><a href="#" className="underline-hover">eCommerce Solutions</a></li>
//             <li><a href="#" className="underline-hover">SEO Services</a></li>
//             <li><a href="#" className="underline-hover">WordPress Development</a></li>
//             <li><a href="#" className="underline-hover">Woocommerce Development</a></li>
//             <li><a href="#" className="underline-hover">Magento Development</a></li>
//             <li><a href="#" className="underline-hover">Mobile Apps Development</a></li>
//             <li><a href="#" className="underline-hover">Custom Application Development</a></li>
//             <li><a href="#" className="underline-hover">Digital Marketing</a></li>
//           </ol>
//         </li>
//         <li><a href="#" className="underline-hover">Work</a></li>
//         <li><a onClick={()=> navigate('/client')} className="underline-hover">Clients</a></li>
//         <li><a href="#" className="underline-hover">Career</a></li>
//         <li><a href="#" className="underline-hover">Blogs</a></li>
//       </ul>
//       <div className={`navbar-getintouch-btn ${scrolled ? 'scrolled-btn' : ''}`}>Get in Touch →</div>
// </nav>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { ChevronDown, X, Menu } from 'lucide-react'; // lucide-react icons
import BlogListPage from '../Components/BlogList';

const Navbar = ({ isHome }) => {
  const [scrolled, setScrolled] = useState(!isHome);  // <-- initial scrolled true if NOT home
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      if (!isHome) {
        // Non-home page - always scrolled true
        setScrolled(true);
      } else {
        // Home page - toggle based on scroll position
        setScrolled(window.scrollY > 50);
      }
    };

    // Call once on mount to set initial state correctly
    handleScroll();


  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 50);
  //   };
    window.addEventListener("scroll", handleScroll);
     // Cleanup
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  return (
    <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
      <div className="navbar-logo" onClick={() => navigate('/')}><img  src={scrolled ? "/pravisht-logo.svg" : "/pravisht-logo_why.svg"}
    alt="Logo"/></div>

      {/* Hamburger button - visible only on mobile */}
      <button className="mobile-menu-btn" onClick={() => setMenuOpen(true)} aria-label="Open menu">
        <Menu size={30} />
      </button>

      {/* Desktop links */}
      <ul className="navbar-links">
        <li><a onClick={() => navigate('/About-us')} className="underline-hover">About Us</a></li>
         <li className="dropdown">
           <a href="#" className="underline-hover">
          Our Services <ChevronDown size={16} className="dropdown-icon" />
         </a>
           <ol className="dropdown-menu">
              <li><a href="/technology-developmen-services" className="underline-hover">Technology Development Services</a></li>
              <li><a href="/data-analytics-services" className="underline-hover" >Data &amp; Analytics Services</a></li>
              <li><a href="/next-genTesting-services" className="underline-hover" onClick={() => navigate('')}>Next Gen Testing Services</a></li>
              <li><a href="/aiml-services" className="underline-hover" onClick={() => navigate('')}>AI/ML Services</a></li>
              <li><a href="/mobile-app-devlopment-services" className="underline-hover" onClick={() => navigate('')}>Enterprise Mobile App Development</a></li>
              <li><a href="sales-force-competencies-services" className="underline-hover" onClick={() => navigate('')}>Salesforce Competencies</a></li>
              <li><a href="/power-platform-services" className="underline-hover" onClick={() => navigate('')}>Microsoft Power Platform Services</a></li>               
          </ol>
         </li>
         {/* <li><a href="#" className="underline-hover" onClick={() => navigate('/Ourprojects')}>Our Projects</a></li> */}
         {/* <li><a href="#" className="underline-hover">Clients</a></li> */}
         <li><a  className="underline-hover" onClick={() => navigate('/Our-Team')}>Our Team</a></li>
         <li><a  className="underline-hover"  onClick={() => navigate('/Career')}>Career</a></li>
         <li><a  className="underline-hover" onClick={() => navigate('/Blog')}>Blog</a></li>
      </ul>
      <div className={`navbar-getintouch-btn ${scrolled ? 'scrolled-btn' : ''}`} onClick={() => navigate('/Contact-us')}>Get in Touch →</div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <img src="/pravisht-logo.svg" alt="Logo" />
          <button className="close-menu-btn" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            <X size={24} />
          </button>
        </div>

        <ul className="mobile-menu-links">
          <li><a onClick={() => {navigate('/AboutUs'); setMenuOpen(false);}}>About Us</a></li>
          <li>
            <details>
              <summary>Our Services <ChevronDown size={16} /></summary>
              <ul>
               <li><a href="/technology-developmen-services" className="underline-hover">Technology Development Services</a></li>
              <li><a href="/data-analytics-services" className="underline-hover" >Data &amp; Analytics Services</a></li>
              <li><a href="/next-genTesting-services" className="underline-hover" onClick={() => navigate('')}>Next Gen Testing Services</a></li>
              <li><a href="/aiml-services" className="underline-hover" onClick={() => navigate('')}>AI/ML Services</a></li>
              <li><a href="/mobile-app-devlopment-services" className="underline-hover" onClick={() => navigate('')}>Enterprise Mobile App Development</a></li>
              <li><a href="sales-force-competencies-services" className="underline-hover" onClick={() => navigate('')}>Salesforce Competencies</a></li>
              <li><a href="/power-platform-services" className="underline-hover" onClick={() => navigate('')}>Microsoft Power Platform Services</a></li>               
          
              </ul>
            </details>
          </li>
          {/* <li><a href="#">Our Projects</a></li> */}
          <li><a  onClick={() => navigate('/Our-Team')}>Our Team</a></li>
          <li><a onClick={() => {navigate('/CareersSection'); setMenuOpen(false);}}>Career</a></li>
          <li><a  onClick={() => {navigate('/all-blogs'); setMenuOpen(false);}}>Blog</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

